/**
 * Release 3 D — private boards (S2). The generated `Board` type gains `visibility` / `owner_member_id` with the Release 3
 * contract; these readers tolerate older payloads (and mocks) that do not carry the fields yet.
 */
import type { Board } from '@/lib/api/types';

export type BoardVisibility = 'workspace' | 'private';

type BoardWithVisibility = Board & { visibility?: BoardVisibility | null; owner_member_id?: string | null };

export function boardVisibility(b: Board | null | undefined): BoardVisibility {
  return (b as BoardWithVisibility | null | undefined)?.visibility === 'private' ? 'private' : 'workspace';
}

export function boardOwnerId(b: Board | null | undefined): string | null {
  return (b as BoardWithVisibility | null | undefined)?.owner_member_id ?? null;
}

export const isPrivateBoard = (b: Board | null | undefined): boolean => boardVisibility(b) === 'private';
